import Vue from 'vue'
import Vuex from 'vuex'
import CKEditor from '@ckeditor/ckeditor5-vue2';

import offices from './modules/offices'
import office_groups from './modules/office_groups'
import auth from './modules/auth'
import permissions from './modules/permissions'
import permission_groups from './modules/permission_groups'
import users from './modules/users'
import record_filings from './modules/record_filings'
import record_categories from './modules/record_categories'
import record_folders from './modules/record_folders'
import record_files from './modules/record_files'
import positions from './modules/positions'
import actions from './modules/actions'
import routes from './modules/routes'
import document_types from './modules/document_types'
import documents from './modules/documents'
import route_statuses from './modules/route_statuses'
import sub_routes from './modules/sub_routes'
import route_comments from './modules/route_comments'
import senders from './modules/senders'
import records from './modules/records'
import document_categories from './modules/document_categories'
import file_imports from './modules/file_imports'
import dashboard from './modules/dashboard'

Vue.use(Vuex)
Vue.use( CKEditor );

export default new Vuex.Store({
    modules: {
        offices,
        office_groups,
        auth,
        permissions,
        permission_groups,
        users,
        record_filings,
        record_categories,
        record_folders,
        record_files,
        positions,
        actions,
        routes,
        document_types,
        documents,
        route_statuses,
        sub_routes,
        route_comments,
        senders,
        records,
		document_categories,
        file_imports,
        dashboard
    },
    state: {
        count: 0
    },
    mutations: {
        increment(state) {
            state.count++
        }
    }
});
